import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=2ff136f1&scoped=true&"
import script from "./Dispositivos.vue?vue&type=script&lang=js&"
export * from "./Dispositivos.vue?vue&type=script&lang=js&"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=2ff136f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff136f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
